// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1R65h","notes":"Notes_notes__I2s8J","note":"Notes_note__3aRfC","markdown":"Notes_markdown__2jDpY"};